//imports
import {
    DEVICES_BY_STATUS_REQUEST,
    DEVICES_BY_STATUS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    //loading: false
};
//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DEVICES_BY_STATUS_REQUEST:
            return { ...state, [`${action.payload.gadget}-loading`]: true }

        case DEVICES_BY_STATUS_RESULT:
            return {
                ...state,
                [`${action.payload.id}-loading`]: false,
                [`${action.payload.id}-items`]: action.payload?.clear
                    ? action?.payload?.data?.items || []
                    : [...state[`${action.payload.id}-items`], ...action?.payload?.data?.items],
                [`${action.payload.id}-total`]: action?.payload?.data?.total || 0
            }

        case CLEAR_REDUX:
            return ["", "UNIT_BY_STATUS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};